
const AdminDashboardView = {
  all: "all",

  // account is in TDA_PORTFOLIO_STATE or TEST_PORTFOLIO_STATE
  live: "live",

  // Has unexecuted rebalance request
  rebalance: "rebalance",

  // Is in ONBOARDING_STATE and not yet stale
  onboarding: "onboarding",

  // Is in ONBOARDING_STATE, and stale
  onboarding_stale: "onboarding_stale",

  // Funding payment has not completed
  not_funded: "not_funded",

  // User has not confirmed account yet
  password_not_set: "password_not_set",
}

const PorfolioPerfomance = {
  IN_BAND: "IN_BAND",
  OVERPERFORM: "OVERPERFORM",
  UNDERPERFORM: "UNDERPERFORM",
}

export { AdminDashboardView, PorfolioPerfomance };